<div class="container top-space">
  <form [formGroup]='requestForm'>
    <form formGroupName='detailsDto'>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="firstName">First Name:</label>
            <input type="text" class="form-control" name="firstName" formControlName='firstName' readonly>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="LastName">LastName:</label>
            <input type="text" class="form-control" formControlName='lastName' name="LastName" readonly>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="DOB">DOB:</label>
            <input type="text" class="form-control" name="DOB" formControlName='dob' readonly>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="gender">Gender:</label>
            <input type="text" class="form-control" name="Gender" formControlName='genderId' readonly>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="phone">Phone Number:</label>
            <input type="text" class="form-control" name="Phone number" formControlName='phoneNumber' readonly>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="form-group">
            <label for="relation">Relation:</label>
            <input type="text" class="form-control" name="Relation" formControlName="relation" readonly>
          </div>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="Mode of Consult">Mode of Consult:</label>
          <input type="text" class="form-control" name="Mode of Consult" formControlName="modeOfConsultation" readonly>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="Appointment">Appointment:</label>
          <!--  -->
          <input type="text" class="form-control" formControlName="appointmentTime" name="Appointment"
            (click)="(changeAppointmentDate)? true:openModal(appointmentSchduler)" [readonly]="changeAppointmentDate">
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="Additional Info">Additional Info:</label>
          <input type="text" class="form-control" name="Additional Info" formControlName="additionalInfo" readonly>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="Mode of Consult">Referred By:</label>
          <input type="text" class="form-control" name="Mode of Consult" formControlName="refferedBy" readonly>
        </div>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
        <div class="form-group">
          <label for="Appointment">Medical Records</label>
          <div class="medical-records">
            <span *ngIf="getAppointmentInfo?.AppoitmentDetails?.files.length >0">
              <p *ngFor="let file of getAppointmentInfo?.AppoitmentDetails?.files;let i=index">
                <small>{{file.fileName}}{{i === getAppointmentInfo.AppoitmentDetails.files.length-1 ? '' :
                  ',&nbsp;'}}</small>
              </p>
            </span>
          </div>
        </div>

      </div>
      <div class="col-lg-4 col-md-4 col-sm-12">
      </div>
    </div>
  </form>


  <div class="row text-center">
    <button class="mt-4 button2" type="button" *ngIf="changeAppointmentDate" (click)="goback()">Cancel</button>

    <button class="mt-4 button1" type="button" *ngIf="changeAppointmentDate"
      (click)="(points > 0)?openModal(payment,getAppointmentInfo?.AppoitmentDetails?.appoitmentId):make_payment(getAppointmentInfo?.AppoitmentDetails?.appoitmentId)">Confirm
      Appointment</button>
    <button class="mt-4 button2" type="button" *ngIf="!changeAppointmentDate" (click)="refund()">Refund</button>
    <button class="mt-4 button1" type="button" *ngIf="!changeAppointmentDate" (click)="reschduleAppointment()">Save
      Appointment</button>

  </div>
</div>


<ng-template #payment>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Message</h4>
    <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
        class="bi bi-x-circle"></i></button>
  </div>
  <!-- Modal body -->
  <div class="modal-body">
    <p class="text-center" *ngIf="points > 0">Your Points {{points}}</p>
    <p class="text-center">{{modalService.config.initialState.message}}</p>
  </div>
  <!-- Modal footer -->
  <div class="modal-footer">
    <button type="button" class="btn button1"
      (click)="makePaymentOnPoints(modalService.config.initialState.appId);modalClose()">POINTS</button>
    <span class="or">OR</span>
    <button type="button" class="btn button2"
      (click)=" make_payment(modalService.config.initialState.appId);modalClose()">OTHERS</button>
  </div>
</ng-template>

<ng-template #msg>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Message</h4>
    <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
        class="bi bi-x-circle"></i></button>
  </div>
  <!-- Modal body -->
  <div class="modal-body">
    <p class="text-center">{{modalService.config.initialState.message}}</p>
  </div>
  <!-- Modal footer -->
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-danger" (click)="modalClose()">CANCEL</button> -->
    <button type="button" class="btn-blue" (click)="modalClose()">OK</button>
  </div>
</ng-template>


<ng-template #appointmentSchduler>
  <div class="calendar-container">
    <div class="row">
      <p class="col-md-4 text-left"></p>
      <h4 class="col-md-4 text-center title">Appointment Calendar</h4>
      <i (click)="modalService.hide()" class="bi bi-x-circle text-right"></i>
      <!-- <button type="button" class="col-md-1 cancelBtn" (click)="modalService.hide()">cancel</button> -->
    </div>
    <div class="row mt-4">
      <div class="col-md-6 col-sm-6 col-xs-6 text-left">
        <h3 class="mt-0">{{ viewDate | calendarSchedulerDate:(view +
          'ViewTitle'):locale:weekStartsOn:excludeDays:viewDays:startsWithToday }}</h3>
        <!-- <select #viewDayOptionSelect1 class="form-control d-none d-md-block d-xl-none" [(ngModel)]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect1.value)">
              <option [value]="1">Un giorno</option>
              <option [value]="3">Tre giorni</option>
              <option [value]="7">Una settimana</option>
          </select> -->

      </div>
      <div class="col-md-6 col-sm-6 col-xs-6 margintop text-right">
        <div class="row ">
          <div class="col-6 d-md-none d-xl-flex col-xl-6 valign-center text-right">
            <!-- <select #viewDayOptionSelect2 class="form-control m-1" [ngModel]="viewDays" (change)="viewDaysOptionChanged(viewDayOptionSelect2.value)">
                <option [value]="1">Un giorno</option>
                <option [value]="3">Tre giorni</option>
                <option [value]="7">Una settimana</option>
            </select> -->
          </div>
          <div class="col-6 col-md-12 col-xl-6">
            <div class="btn-group m-1" role="group">
              <button type="button" class="btn btn-primary btnFont" mwlCalendarPreviousView [view]="view"
                [(viewDate)]="viewDate" [daysInWeek]="viewDays" [excludeDays]="excludeDays" [disabled]="prevBtnDisabled"
                (viewDateChange)="dateOrViewChanged()" (click)="getSchedular(viewDate)">
                <span class="valign-center">
                  <i class="bi bi-chevron-left">Previous</i>
                </span>
              </button>
              <button type="button" class="btn btn-primary btnFont" mwlCalendarToday [(viewDate)]="viewDate"
                (viewDateChange)="dateOrViewChanged()" (click)="getSchedular(viewDate)">
                <span class="valign-center">
                  <i class="">Today</i>
                </span>
              </button>
              <button type="button" class="btn btn-primary btnFont" mwlCalendarNextView [view]="view"
                [(viewDate)]="viewDate" [daysInWeek]="viewDays" [excludeDays]="excludeDays" [disabled]="nextBtnDisabled"
                (viewDateChange)="dateOrViewChanged()" (click)="getSchedular(viewDate)">

                <span class="valign-center">
                  <i class="bi bi-chevron-right">Next</i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <calendar-scheduler-view [viewDays]="viewDays" [viewDate]="viewDate" [events]="events" [locale]="locale"
        [responsive]="false" [weekStartsOn]="weekStartsOn" [excludeDays]="excludeDays"
        [startsWithToday]="startsWithToday" [hourSegments]="hourSegments" [dayStartHour]="dayStartHour"
        [dayEndHour]="dayEndHour" [dayModifier]="dayModifier" [hourModifier]="hourModifier"
        [segmentModifier]="segmentModifier" [eventModifier]="eventModifier" [showEventActions]="true"
        [showSegmentHour]="true" [zoomEventOnHover]="true" (viewDaysChanged)="viewDaysChanged($event)"
        (dayHeaderClicked)="dayHeaderClicked($event.day)" (segmentClicked)="segmentClicked('Clicked', $event.segment)"
        (eventClicked)="eventClicked('Clicked', $event.event)" (eventTimesChanged)="eventTimesChanged($event)"
        [refresh]="refresh">

      </calendar-scheduler-view>
    </div>


  </div>


  <!-- (hourClicked)="hourClicked($event.hour)" -->

</ng-template>